<template>
  <div>
    <vue-headful
      title="Extracciones"
      description="Además de poder asistir a nuestro laboratorio para realizar su análisis de sangre, contámos con el servicio de extracción a domicilio y profesionales capacitados para la atención a niños y ancianos."
    />
    <div class="front front--page">
      <div v-parallax="0.1" v-parallax.centerX class="bg-parallax bg-parallax--extracciones"></div>
      <div class="container">
        <h1 class="title title--big color--white">Extracciones</h1>
        <div class="separator separator--white"></div>
      </div>
    </div>
    <div class="page-body">
      <div class="container">
          <h2 class="color--light-blue">Además de poder asistir a nuestro laboratorio para realizar su análisis de sangre, contámos con el servicio de extracción a domicilio y profesionales capacitados para la atención a niños y ancianos.</h2>

          <div class="page-block">
            <div class="row">
              <div class="col-sm-6">
                <div class="margin-bottom-30">
                  <img src="../../assets/img/extracciones-domicilio.jpg" alt="" class="img-responsive">
                  <br>
                  <h2 class="text-uppercase color--blue">Extracciones Domiciliarias</h2>
                  <p>Además de poder asistir a nuestro laboratorio para realizar su análisis de sangre, si vos o un familiar necesita realizarse una extracción y se encuentra imposibilitado de dirigirse a nuestro laboratorio, en Varelab realizamos extracciones a domicilio.</p>
                  <br>
                  <p>Para solicitar dicha extracción, debe presentarse un familiar directo con los datos de la persona que va a realizarse la extracción para coordinar la fecha y hora de la misma</p>
                  <br>
                  <div class="separator separator--blue" style="width: 200px"></div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="margin-bottom-30">
                  <img src="../../assets/img/extracciones-kids.jpg" alt="" class="img-responsive">
                  <br>
                  <h2 class="text-uppercase color--blue">Extracciones a Niños y Ancianos</h2>
                  <p>En Varelab nos especializamos en la realización de extracciones a niños y adultos mayores, contando con profesionales altamente capacitados para realizar estos tipos de estudios.</p>  
                  <p>En nuestras instalaciones contamos con profesionales altamente capacitados para la realización de este tipo de extracciones.</p>
                  <br>
                  <p>En el caso de las extracciones pediátricas recomendamos a los padres tener en cuenta los siguientes aspectos:</p>
                  <br>
                  <ul class="list--clean color--blue">
                    <li><b>1)</b> Contarle al niño "Para Qué" y “Por Qué” de la extracción.</li>
                    <li><b>2)</b> Explíquele "Cómo" será el proceso, comentándole que es una suave punción con una duración mínima.</li>
                    <li><b>3)</b> Refuerce el dato de lo importante que es su participación en esto, manteniendo su brazo quieto durante la extracción, para que el proceso sea rápido y la molestia leve.</li>
                    <li><b>4)</b> Evite siempre, el engaño para lograr su cooperación.</li>
                  </ul>
                  <br>
                  <div class="separator separator--blue" style="width: 200px"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'extracciones'
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Servicios/Extracciones.vue